import {Component, OnInit} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {IdService} from "../../../../../services/id/id.service";

@Component({
    selector: "xlog-saml-metadata",
    // templateUrl: "./saml-metadata.component.pug",
    template: '<div>{{ xmlString }}</div>',
    styles: ["div{ white-space: pre; }"],
    standalone: false
})
export class SamlMetadataComponent implements OnInit {
    clientId: string;
    xmlString: string;

    constructor(
        private id: IdService,
        private route: ActivatedRoute,
    ) {}

    ngOnInit() {
        this.route.params.subscribe((params: any) => {
            this.clientId = params.clientId;
            const routerElement = document.getElementsByClassName('section left')[0];
            // Make router to use all the width
            routerElement.classList.remove('col-sm-6');
            routerElement.classList.add('col-sm-12');
            // hide marketing info
            const marketingElement = document.getElementsByClassName('section right')[0];
            marketingElement.classList.add('hide');
        });
        const success = (res) => {
            this.xmlString = res.data;
        };
        const error = (res) => {
            console.log('There is an error');
            console.log(res);
        };
        this.id.getSamlMetadata(this.clientId).subscribe(success, error);
    }
}
